<div class="text-center">
  <div class="error mx-auto"><i class="fas fa-times-circle"></i></div>
  <p class="lead5" style="font-size: 2.5rem">
    {{ "system_handler.error.titulo" | translate }}
  </p>
  <p [innerHTML]="'system_handler.error.text' | translate"></p>
  <br />
  <div class="card" style="display: inline-block; text-align: left !important">
    <div class="card-body" style="line-break: anywhere">
      <p class="no-margin-bottom">
        <ng-container *ngIf="data_error?.estado">
          <strong>{{ "system_handler.error.codigo" | translate }}: </strong>
          {{ data_error?.estado }}<br />
        </ng-container>
        <ng-container *ngIf="data_error?.nivel">
          <strong>{{ "system_handler.error.nivel" | translate }}: </strong>
          {{ data_error?.nivel }}<br />
        </ng-container>
        <ng-container *ngIf="data_error?.tipo">
          <strong>{{ "system_handler.error.type" | translate }}: </strong>
          {{ data_error?.tipo }}<br />
        </ng-container>
        <strong>URL: </strong> {{ data_error?.path }}<br />
        <br />
        <span [innerHTML]="data_error?.message"></span>
      </p>
    </div>
  </div>
</div>
